import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";

const state = {
  empAttendences: [],
  empAttendence: {},
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  pagination: {},
};
const getters = {
  EmpAttendenceListGet: (state) => state.empAttendences,
  // empAttendenceGet: (state) => state.empAttendence,
  empAttendenceGet: (state) => {
    const datetime = state.empAttendence.datetime;
    if (!datetime) {
      return { ...state.empAttendence };
    }
    const [date, time] = datetime.split(" ");
    return { ...state.empAttendence, date, time };
  },
  paginationGet: (state) => state.pagination,
};
const actions = {
  getEmpAttendence({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`employee_attendences?page=${page}`).then(
      (obj) => {
        var result = obj.data.data;
        const pageResult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("EmpAttendenceListSet", result);
        commit("setPagination", pageResult);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getEmpAttendenceById({ commit }, payload) {
    service.getFun(`employee_attendences/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("getEmpAttendenceById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addEmpAttendence({ commit }, payload) {
    console.log(payload, "payload");
    service
      .postFun(
        service.deleteNullValues(payload),
        `employee_attendences/create`,
        null,
        {
          action: "getEmpAttendence",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("addEmpAttendencetatus", result.success);
            toast(result.message);
          } else {
            commit("addEmpAttendencetatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editEmpAttendence({ commit }, payload) {
    console.log(payload, "payload");

    service
      .postFun(
        service.deleteNullValues(payload),
        `employee_attendences/edit/${payload.id}`,
        null,
        {
          action: "getEmpAttendence",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editEmpAttendencetatus", result.success);
            toast(result.message);
          } else {
            commit("editEmpAttendencetatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteEmpAttendence({ commit }, payload) {
    service
      .postFun(null, `employee_attendences/delete/${payload.payload}`, null, {
        action: "getEmpAttendence",
        page: store.state.page.page,
      })
      .then(
        (result) => {
          if (result) {
            commit("deleteEmpAttendencetatus", result.success);
            toast(result.message);
          } else {
            commit("deleteEmpAttendencetatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  EmpAttendenceListSet(state, empAttendences) {
    state.empAttendences = empAttendences;
  },
  addEmpAttendencetatus(state, Status) {
    state.addStatus = Status;
  },
  getEmpAttendenceById(state, empAttendence) {
    state.empAttendence = empAttendence;
  },
  editEmpAttendencetatus(state, Status) {
    state.editStatus = Status;
  },
  deleteEmpAttendencetatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
